import React, { useState, useEffect } from "react";
import "./CreateUserModal.css";
import * as Yup from "yup";
import Form from "../../form/components/Form/Form";
import FormField from "../../form/components/FormField/FormField";
import Button from "../../form/components/Button/Button";
import ErrorMessage from "../../form/components/ErrorMessage/ErrorMessage";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
// import { createCourseContent } from '../../../services/courseContent';
import { registerUser } from "../../../services/auth";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";


import {
  getAuth,
  updateProfile,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { collection, addDoc, getDocs, setDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase/firebase-config";
import TextInput from "../../form/Textinput";
import { registerNewDoc } from "../../../services/medAuth";

const initialValues = {
  email: "",
  password: "",
};

const override = {
  marginTop: "20px",
};

function CreateUserModal({ onClose, onContentAdded }: any) {
  
  const [error, setError] = useState<any>(null);
  const [selectedSpeciality, setSelectedSpeciality] = useState(null);
  const [displayName, setDisplayName] = useState(null);
  const [loading, setLoading] = useState(false);

  const [allSpecialities, setAllSpeciialities] = useState([]);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email().required("Email is required"),
    password: Yup.string().required("Password required"),
  });

  const handleAddUser = async (values: any) => {
    setError(null);
  
    let email = values.email;
    let password = values.password;
  
    setLoading(true);
  
    try {
      let reqData = { email, password, displayName, selectedSpeciality };

      const response = await registerNewDoc(reqData);
  
      if (response.ok) {
        toast.success('User Created', {
          pauseOnHover: false,
          closeOnClick: true,
        });
        setLoading(false);
        onContentAdded();
      } else {
        // console.log('RES: ', response)
        toast.error("An error occurred while creating user", {
          pauseOnHover: false,
          closeOnClick: true,
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error creating user: ", error);
      toast.error("An error occurred while creating user", {
        pauseOnHover: false,
        closeOnClick: true,
      });
      setLoading(false);
    }
  };
  
  // const handleAddUser = async (values: any) => {
  //   setError(null);

  //   let email = values.email;
  //   let password = values.password;
     
  //   setLoading(true);

  //   const auth = getAuth();

  //   createUserWithEmailAndPassword(auth, email, password)
  //   .then((userCredential) => {
  //     const user = userCredential.user;

  //     if (userCredential) {
  //       updateProfile(user, {
  //         displayName: displayName,
  //       })
  //         .then(() => {
  //           // console.log(user.displayName);
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });

  //       try {
  //         const docRef = setDoc(doc(db, "users", userCredential.user.uid),
  //         {
  //           email: email,
  //           speciality: selectedSpeciality == 'lab'  ? 'Lab Technician' : selectedSpeciality == 'pt' ? 'Pathology' : selectedSpeciality == 'admin' ? 'Admin' : selectedSpeciality,
  //           username: displayName,
  //           role: selectedSpeciality,
  //           status: true,
  //         });

  //       } catch (e) {
  //         console.error("Error adding document: ", e);
  //       }
  //     }
  //     toast.success("User Created", {
  //       pauseOnHover: false,
  //       closeOnClick: true,
  //     });
  //     setLoading(false);
  //     onContentAdded();
  //   })
  //   .catch((error) => {

  //     setLoading(false);
  //     toast.error("ERROR", {
  //       pauseOnHover: false,
  //       closeOnClick: true,
  //     });
  //   });
   
  // };

   const fetchSpecialities = async() => {
    let res: any = [];
    const specialities = await getDocs(collection(db, "Specialities"));

      try {

        specialities.forEach((speciality) => {
            res.push({
              id: speciality.id,
              ...speciality.data(),
            });
    
        });

        res.sort((a: any, b: any) => a.speciality_name.localeCompare(b.speciality_name));

        setAllSpeciialities(res);
      } catch (error) {
        
      }
   }

  useEffect(() => {
    fetchSpecialities();
  },[])


    // SCRIPT
  // USERS DATA
  let usersData =  [
    {
      id: 'qDmMHHrFKwXXXRec5rESoXIX8972',
      emai: 'jamesdoe@gmail.com'
    },
    {
      id: 'RBDu3QALDoMDg9kazB7Dj9qop9j1',
      emai: 'frankdoe237@gmail.com'
    },
    {
      id: 'rQTDCKgZaxbzH01ilzq9K6NMmdw1',
      emai: 'frankdoe@gmail.com'
    },
    {
      id: '4MC8PZQowIYAwDVQVGjV0J6odl33',
      emai: '+237654451039@medarc.org'
    },
    {
      id: '4sM4Of2dopMmwOTSvvJDIYlVAfy1',
      emai: '+237696582104@medarc.org'
    },
    {
      id: '1Apx92LGnEZBhklmYjjIk8e3S1I2',
      emai: '+237679365244@medarc.org'
    },
    {
      id: '5PhoJ2j9vKYxhtiF8SoBQCDGCZm2',
      emai: '+237656872427@medarc.org'
    },
    {
      id: 'cnMrjwUKwBRcKVDEWNAffQhN7Qq1',
      emai: '+237680194677@medarc.org'
    },
    {
      id: 'KQotj146Aycz0EPy1UG3f2sURJe2',
      emai: '+237677511626@medarc.org'
    },
    {
      id: 'CAOFTWMXQ2fIa4RejvMKvR1VFSZ2',
      emai: '+237650967837@medarc.org'
    },
    {
      id: 'rcusSJpv1pPvQdcdprOZ9yqWXNa2',
      emai: '+237699158562@medarc.org'
    },
    {
      id: 'd1UkO3gCEPenFCEfpWsP3abx0Zn1',
      emai: '+237678528975@medarc.org'
    },
    {
      id: 'fX9VA1VJ3CdS2ofqqdapOcLfp0j2',
      emai: '+237653536586@medarc.org'
    },
    {
      id: 'myhLmHdlzaaf0AHyPM0kU830adf1',
      emai: 'lab2@gmail.com'
    },
    {
      id: 'RVKH6PozHMRGYEkynhlYKfXsedo2',
      emai: '+237676583325@medarc.org'
    },
    {
      id: 'c2RbLyCkgCZGlkqmV29hghI94eN2',
      emai: '+237652936118@medarc.org'
    },
    {
      id: 'MfPEX1xYNjfIUoCIfrXOK5qCPnJ2',
      emai: '+237672043732@medarc.org'
    },
    {
      id: 'Y0HMCVfweRWtHqvT0pQhrFPepOp2',
      emai: '+237699893057@medarc.org'
    },
    {
      id: '31eusW941wcoryoQ2osNVselKUu2',
      emai: '+237691896165@medarc.org'
    },
    {
      id: 'FcbUJEew3gSbpMzVs2UTpLQgzU32',
      emai: '+237620978794@medarc.org'
    },
    {
      id: 'BODTfHZNTnMcgedmolE37s1sUGd2',
      emai: 'lab@gmail.com'
    },
    {
      id: 'Suet8jSlCgXCqBZ96jupt2OA5Tw1',
      emai: 'doctor@gmail.com'
    },
    {
      id: 'T3THhGWufgXOQIGNTWZsZeTcufZ2',
      emai: 'user@gmail.com'
    },
    {
      id: 'DkMPTmiDDcOtUP4uM39318mYDT03',
      emai: 'admin@gmail.com'
    },
    {
      id: 'GbAcMLkANLSB5JuqxgH3RoX6nEN2',
      emai: 'romeomanghe37@gmail.com'
    },
    {
      id: 'j4cZgW8eA0cqcMevX8rSQhGXYBX2',
      emai: 'drjoel@gmscope.org'
    },
    {
      id: 'ptX4cOw9BIf4mO2kyNV4plonQim2',
      emai: 'demo@gmscope.org'
    },
    {
      id: 'piufJXo8RJelQT5lC7u0dG8Tk9K2',
      emai: 'blessing@gmail.com'
    },
    {
      id: '9iWsFOjLQMSHPncEnnszM7mLGi83',
      emai: 'cleverview7@gmail.com'
    },
    {
      id: 'JzMnzF1qLodn7gyFKDXYT8AUDig1',
      emai: 'sedoid@gmail.com'
    },
    {
      id: 'lji21c6Vn0WPV3MduZBEqAiv2Jo1',
      emai: 'conrad@gmail.com'
    },
    {
      id: '5AobZx6UqyLKiEbiyxo1ugZ2YTc2',
      emai: 'test@gmail.com'
    }
  ];


  const createNewCol = async() => {
    let colData = [
      {
          "id": "JzMnzF1qLodn7gyFKDXYT8AUDig1",
          "data": {
              "role": "admin",
              "email": "sedoid@gmail.com",
              "speciality": "pt",
              "status": true,
              "username": "Sedoid"
          }
      },
      {
          "id": "lji21c6Vn0WPV3MduZBEqAiv2Jo1",
          "data": {
              "status": true,
              "speciality": "pt",
              "username": "T. Conrad ",
              "email": "conrad@gmail.com"
          }
      },
      {
          "id": "piufJXo8RJelQT5lC7u0dG8Tk9K2",
          "data": {
              "username": "Blessing",
              "email": "blessing@gmail.com",
              "speciality": "pt",
              "status": true
          }
      },
      {
          "id": "BODTfHZNTnMcgedmolE37s1sUGd2",
          "data": {
              "role": "lab",
              "speciality": "lab",
              "username": "Lab Tech",
              "email": "lab@gmail.com",
              "status": false
          }
      },
      {
          "id": "Suet8jSlCgXCqBZ96jupt2OA5Tw1",
          "data": {
              "username": "doctor",
              "speciality": "gp",
              "status": true,
              "role": "doc",
              "email": "doctor@gmail.com"
          }
      },
      {
          "id": "qDmMHHrFKwXXXRec5rESoXIX8972",
          "data": {
              "email": "jamesdoe@gmail.com",
              "role": "lab",
              "status": true,
              "speciality": "Lab Technician",
              "username": "James Doe"
          }
      },
      {
          "id": "j4cZgW8eA0cqcMevX8rSQhGXYBX2",
          "data": {
              "username": "Dr Joel Awoumou Belinga",
              "status": true,
              "email": "drjoel@gmscope.org",
              "speciality": "pt"
          }
      },
      {
          "id": "GbAcMLkANLSB5JuqxgH3RoX6nEN2",
          "data": {
              "username": "Manghe Romeo",
              "speciality": "pt",
              "status": true,
              "email": "romeomanghe37@gmail.com"
          }
      },
      {
          "id": "RBDu3QALDoMDg9kazB7Dj9qop9j1",
          "data": {
              "speciality": "Pathology",
              "email": "frankdoe237@gmail.com",
              "role": "pt",
              "username": "Frank Doe",
              "status": true
          }
      },
      {
          "id": "T3THhGWufgXOQIGNTWZsZeTcufZ2",
          "data": {
              "email": "user@gmail.com",
              "speciality": "pt",
              "status": true,
              "role": "lab",
              "username": "user"
          }
      },
      {
          "id": "ptX4cOw9BIf4mO2kyNV4plonQim2",
          "data": {
              "status": true,
              "email": "demo@gmscope.org",
              "speciality": "pt",
              "username": "Demo"
          }
      },
      {
          "id": "DkMPTmiDDcOtUP4uM39318mYDT03",
          "data": {
              "username": "admin",
              "email": "admin@gmail.com",
              "role": "admin",
              "speciality": "pt",
              "status": true
          }
      },
      {
          "id": "myhLmHdlzaaf0AHyPM0kU830adf1",
          "data": {
              "username": "Lab 2",
              "status": true,
              "role": "lab",
              "email": "lab2@gmail.com",
              "speciality": "Lab Technician"
          }
      },
      {
          "id": "9iWsFOjLQMSHPncEnnszM7mLGi83",
          "data": {
              "username": "Clever Doc",
              "status": true,
              "speciality": "gp",
              "email": "cleverview7@gmail.com",
              "invited_slides": [
                  {
                      "slide": "BINDEKI I.svs",
                      "slide_from": "T. Conrad "
                  },
                  {
                      "slide_from": "T. Conrad ",
                      "slide": "ASN 10 (X10).svs"
                  }
              ]
          }
      }
    ] 


    colData.forEach(async (data: any) => {
    
    await setDoc(doc(db, 'users', data.id), data.data);
    })
  }


  return (
    <>
    <div>
      <div className="modal-container" id='create-user-modal'>
        <div className="modal-head">
          <p className="modal-title">Add New User</p>
          <ImCancelCircle
            style={{ cursor: "pointer" }}
            onClick={onClose}
            size={22}
            color="#fff"
          />
        </div>
        <div className="modal-content">
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <BeatLoader
              color="#3080ED"
              loading={loading}
              cssOverride={override}
            />
          </div>
          <form action="" className="auth-form">
            {error && <ErrorMessage error={error} visible={true} />}
            <Form
              initialValues={initialValues}
              onSubmit={handleAddUser}
              validationSchema={validationSchema}
            >
            <p className="label-text">Display Name: </p>
              <TextInput 
                onChange={(e:any) => setDisplayName(e.target.value)}
                placeholder="displayname"
                type="text"
                name="displayName"
            />

              <p className="label-text">Email: </p>
              <FormField name="email" type="general" placeholder="Email" />

              <p className="label-text">Password: </p>
              <FormField
                name="password"
                type="general"
                placeholder="Password"
              />

              <p className="label-text">Select Speciality: </p>
              <select
                onChange={(e: any) => setSelectedSpeciality(e.target.value)}
                className="select-field-modal"
              >
                {/* <option value="admin">All</option>
                <option value="pt">Pathology</option>
                <option value="lab">Lab Technician</option>
                <option value="cardiologist">Cardiologist</option>
                <option value="diabetologist">Diabetologist</option>
                <option value="gp">GP</option> */}

                {
                  allSpecialities.map((sp: any) =>  <option value={sp?.speciality_value}>{sp?.speciality_name}</option>)
                }
              </select>

              {!loading && (
                <Button
                  isOutLined={true}
                  isFullWidth={false}
                  title="CREATE ACCOUNT"
                />
              )}
            </Form>
          </form>
        </div>
      </div>
      <div className="modal-shadow" onClick={onClose}></div>
    </div>
    {/* <div className="modal-overlay"></div> */}
    </>
  );
}

export default CreateUserModal;
